export default "__VITE_ASSET__BSJqx$zF__"